var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("ul", { staticClass: "title-nav" }, [
        _c(
          "li",
          {
            on: {
              click: function($event) {
                return _vm.handleBack()
              }
            }
          },
          [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "title-label" }, [
              _c("i", { staticClass: "material-icons md-18" }, [
                _vm._v("business_center")
              ]),
              _vm._v(" PERMITS (" + _vm._s(_vm.parcel.permits.length) + ")")
            ])
          ]
        )
      ]),
      _vm._v(" "),
      _vm.parcel.permits.length === 0
        ? _c("div", { staticClass: "section-title text-center" }, [
            _vm._v("\n\t\tNo permits for this parcel\n\t")
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.parcel.permits, function(permit, index) {
        return _c("div", { staticClass: "section" }, [
          _c("div", { staticClass: "section-title" }, [
            _vm._v("\n\t\t\t" + _vm._s(permit.typeRaw) + "\n\t\t")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "section-body" }, [
            permit.description !== null
              ? _c("div", { staticClass: "category" }, [
                  _c("div", { staticClass: "category-title" }, [
                    _vm._v("DESCRIPTION")
                  ]),
                  _vm._v(" "),
                  !_vm.parcel.unlocked
                    ? _c(
                        "div",
                        {
                          staticClass: "lock-block mt-2 mb-2",
                          on: { click: _vm.unlock }
                        },
                        [
                          _vm._m(1, true),
                          _vm._v(" "),
                          _c("div", { staticClass: "lock-text" }, [
                            _c("h5", { staticClass: "mb-0 text-white" }, [
                              _vm._v("Unlock to view permit description")
                            ]),
                            _vm._v(" "),
                            _c(
                              "h5",
                              {
                                staticClass: "mb-0 font-weight-light text-light"
                              },
                              [
                                _vm._v(
                                  "$" +
                                    _vm._s(_vm.plans.parcelUnlock.price) +
                                    " to unlock all info for this parcel"
                                )
                              ]
                            )
                          ])
                        ]
                      )
                    : _c("div", { staticClass: "property-row" }, [
                        _c(
                          "div",
                          { staticClass: "text-description property-locked" },
                          [_vm._v(_vm._s(permit.description))]
                        )
                      ])
                ])
              : _vm._e(),
            _vm._v(" "),
            permit.appliedDate !== null ||
            permit.issuedDate !== null ||
            permit.completedDate !== null
              ? _c("div", { staticClass: "category" }, [
                  _c("div", { staticClass: "category-title" }, [
                    _vm._v("DETAILS")
                  ]),
                  _vm._v(" "),
                  permit.appliedDate !== null
                    ? _c("div", { staticClass: "property-row" }, [
                        _c("label", [_vm._v("Applied")]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "property-value-right property-locked"
                          },
                          [
                            _vm._v(
                              "\n\t\t\t\t\t\t" +
                                _vm._s(_vm._f("longDate")(permit.appliedDate)) +
                                "\n\t\t\t\t\t"
                            )
                          ]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  permit.issuedDate !== null
                    ? _c("div", { staticClass: "property-row" }, [
                        _c("label", [_vm._v("Issued")]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "property-value-right property-locked"
                          },
                          [
                            _vm._v(
                              "\n\t\t\t\t\t\t" +
                                _vm._s(_vm._f("longDate")(permit.issuedDate)) +
                                "\n\t\t\t\t\t"
                            )
                          ]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  permit.completedDate !== null
                    ? _c("div", { staticClass: "property-row" }, [
                        _c("label", [_vm._v("Completed")]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "property-value-right property-locked"
                          },
                          [
                            _vm._v(
                              "\n\t\t\t\t\t\t" +
                                _vm._s(
                                  _vm._f("longDate")(permit.completedDate)
                                ) +
                                "\n\t\t\t\t\t"
                            )
                          ]
                        )
                      ])
                    : _vm._e()
                ])
              : _vm._e(),
            _vm._v(" "),
            permit.jurisdictionPermitId
              ? _c("div", { staticClass: "category" }, [
                  _c("div", { staticClass: "category-title" }, [
                    _vm._v("REFERENCES")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "property-row" }, [
                    _c("label", [_vm._v("Source")]),
                    _vm._v(" "),
                    _c("div", { staticClass: "property-value-right" }, [
                      permit && permit.link
                        ? _c(
                            "a",
                            {
                              staticClass: "property-locked",
                              attrs: {
                                href: _vm.jurisdictionPermitURL(
                                  permit.jurisdictionPermitId
                                ),
                                target: "_blank"
                              }
                            },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t#" +
                                  _vm._s(permit.jurisdictionPermitId) +
                                  "\n\t\t\t\t\t\t\t"
                              ),
                              _c("i", { staticClass: "material-icons md-12" }, [
                                _vm._v("open_in_new")
                              ])
                            ]
                          )
                        : _c("span", [
                            _vm._v("#" + _vm._s(permit.jurisdictionPermitId))
                          ])
                    ])
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.unlocked === false
              ? _c(
                  "div",
                  {
                    staticClass: "over-sign-in d-flex",
                    on: { click: _vm.unlock }
                  },
                  [_vm._m(2, true)]
                )
              : _vm._e()
          ])
        ])
      })
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "back-btn" }, [
      _c("i", { staticClass: "material-icons md-18" }, [
        _vm._v("keyboard_arrow_left")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "lock-icon-box" }, [
      _c("i", { staticClass: "material-icons md-36" }, [_vm._v("lock")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "over-sign-in-box align-self-center text-white hover-dk" },
      [
        _c("div", { staticClass: "text-center" }, [
          _c("i", { staticClass: "material-icons text-light md-36" }, [
            _vm._v("lock")
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "text-center" }, [
          _vm._v("\n\t\t\t\t\t\tUnlock to view\n\t\t\t\t\t")
        ])
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-70ebe7da", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70ebe7da","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parcel/parcel-permits.vue
// module id = null
// module chunks = 